<template>
  <div class="legal-text">
    <template v-for="(block, index) in blocks">
      <component
        :is="`h${block.level}`"
        v-if="block.type === 'heading'"
        :key="`h-${index}`"
      >
        <template v-for="(part, partIndex) in block.parts">
          <strong
            v-if="part.bold"
            :key="partIndex"
          >{{ part.text }}</strong>
          <span
            v-else
            :key="partIndex"
          >{{ part.text }}</span>
        </template>
      </component>

      <p
        v-else-if="block.type === 'paragraph'"
        :key="`p-${index}`"
      >
        <template v-for="(part, partIndex) in block.parts">
          <strong
            v-if="part.bold"
            :key="partIndex"
          >{{ part.text }}</strong>
          <span
            v-else
            :key="partIndex"
          >{{ part.text }}</span>
        </template>
      </p>

      <component
        :is="block.ordered ? 'ol' : 'ul'"
        v-else
        :key="`l-${index}`"
      >
        <li
          v-for="(item, itemIndex) in block.items"
          :key="itemIndex"
        >
          <template v-for="(part, partIndex) in item">
            <strong
              v-if="part.bold"
              :key="partIndex"
            >{{ part.text }}</strong>
            <span
              v-else
              :key="partIndex"
            >{{ part.text }}</span>
          </template>
        </li>
      </component>
    </template>
  </div>
</template>

<script>
import parseLegalText from '@/utils/legalText'

export default {
  props: {
    body: {
      type: String,
      default: '',
    },
  },

  computed: {
    blocks() {
      return parseLegalText(this.body)
    },
  },
}
</script>

<style lang="scss" scoped>
$ink: #0f172a;

.legal-text {
  max-width: 68ch;
  font-size: 1rem;
  line-height: 1.7;
  color: #1e293b;

  h2 {
    margin: 2rem 0 0.75rem;
    font-size: 1.35rem;
    font-weight: 700;
    color: $ink;
  }

  h3 {
    margin: 1.75rem 0 0.5rem;
    padding-top: 1.25rem;
    border-top: 1px solid #e2e8f0;
    font-size: 1.08rem;
    font-weight: 700;
    color: $ink;
  }

  h4 {
    margin: 1.25rem 0 0.4rem;
    font-size: 1rem;
    font-weight: 700;
    color: $ink;
  }

  p {
    margin: 0 0 0.85rem;
  }

  ul,
  ol {
    margin: 0 0 1rem;
    padding-left: 1.3rem;
  }

  li {
    margin-bottom: 0.35rem;
  }

  strong {
    color: $ink;
  }

  > :first-child {
    margin-top: 0;
    padding-top: 0;
    border-top: 0;
  }
}
</style>
